import { useDispatch } from "react-redux";
import { setActiveTab } from "../reducers/pageReducer";
import { SidebarTabsType } from "../constants/tabs";
import { useEffect } from "react";

export const useTabActive = (tab: SidebarTabsType) => {
  const dispatch = useDispatch();

  useEffect(() => {
    handleTabActive();
  }, []);

  const handleTabActive = async () => {
    dispatch(setActiveTab(tab));
  };

  return handleTabActive;
};
